import gql from "@/api/gql.js"
import { query, mutation } from "./queries.js"
import resolveApiErrors from "@/api/resolveApiErrors"

export default {
	async individual(variables) {
		const res = await gql({
			query: query.individual,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "individuals"
		})
	},

	async individualCredentials(variables) {
		const res = await gql({
			query: query.individualCredentials,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "individuals"
		})
	},

	async createIndividual(variables) {
		const res = await gql({
			query: mutation.createIndividual,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "createIndividual"
		})
	},

	async individualObjects(variables) {
		const res = await gql({
			query: query.individualObjects,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "individuals"
		})
	},

	async createCompany(variables) {
		const res = await gql({
			query: mutation.createCompany,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "createCompany"
		})
	},

	async update(variables) {
		const res = await gql({
			query: mutation.updateIndividual,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "status"
		})
	},

	async company(variables) {
		const res = await gql({
			query: query.company,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "companies"
		})
	},

	async companyCredentials(variables) {
		const res = await gql({
			query: query.companyCredentials,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "companies"
		})
	},

	async deleteCustomer(variables) {
		const res = await gql({
			query: mutation.deleteCustomer,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "result"
		})
	},

	async companyObjects(variables) {
		const res = await gql({
			query: query.companyObjects,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "companies"
		})
	},

	async policiesOfIndividual(variables) {
		const res = await gql({
			query: query.policiesOfIndividual,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "individuals"
		})
	},

	async policiesOfCompany(variables) {
		const res = await gql({
			query: query.policiesOfCompany,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "companies"
		})
	},

	async createObject(variables) {
		const res = await gql({
			query: mutation.createObject,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "createObject"
		})
	},

	async addLink(variables) {
		const res = await gql({
			query: mutation.addLink,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addLink"
		})
	},

	async inviteIndividual(variables) {
		const res = await gql({
			query: mutation.inviteIndividual,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithoutStatus",
			res,
			resKey: "inviteIndividual"
		})
	},

	async assignRole(variables) {
		const res = await gql({
			query: mutation.assignRole,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addToPermissionGroup"
		})
	}
}
